module.exports = __webpack_public_path__ + "static/media/S1-24-Therkoj-cod44.0997567c.png";